import React, { useState, useRef, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "@fontsource/inter";
import axios from "axios";
import "./App.css";
import ActionBtn from "./Components/actionBtn";
import UsageHistoryModal from "./Components/usageHistoryModal";
import LoadingOverlay from "./Components/spinner";

const Dashboard = () => {
  const [token, setToken] = useState(undefined);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clientId, setClientId] = useState(undefined);
  const [clientLocation, setClientLocation] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasPrev, setHasPrev] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ghlDashboardToken = urlParams.get("token") || undefined; // Get token from the URL
    setToken(ghlDashboardToken);
  }, []); // Empty dependency array to run on mount only
  const handlePageChange = (
    action = "prev",
    reset = false,
    reset_status = false
  ) => {
    let lastItem = list[list.length - 1];
    let firstItem = list[0];
    if (reset_status) {
      setActiveFilter("");
    }
    if (reset) {
      setCurrentPage(1);
      fetchClientData();
    } else if (action == "prev") {
      if (hasPrev) {
        let current = currentPage - 1;
        if (current < 1) current = 1;
        setCurrentPage(current);
        if (current == 1) fetchClientData();
        else fetchClientData(firstItem.id, "");
      }
    } else if (action == "next") {
      if (hasMore) {
        let current = currentPage + 1;
        setCurrentPage(current);
        setHasPrev(true);
        fetchClientData("", lastItem.id);
      }
    }
  };
  useEffect(() => {
    handlePageChange("prev", true);
  }, [activeFilter, token]);

  const fetchClientData = async (ending_before = "", starting_after = "") => {
    if (token) {
      setLoading(true);
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        "https://automations.creativedigital.ai/webhook/invoices",
        {
          token: token,
          ending_before: ending_before == "" ? undefined : ending_before,
          starting_after: starting_after == "" ? undefined : starting_after,
          status: activeFilter == "" ? undefined : activeFilter,
          currentPage,
        },
        {
          headers: headers,
        }
      );
      if (response.status == 200) {
        setList(
          (response.data.data || []).map((row) => {
            return row?.json || {};
          })
        );
        setHasMore(response.data.has_more || false);
        setClientId(response.data.client_id);
        setLoading(false);
      } else {
        setList([]);
        setLoading(false);
      }
      console.log(response);
    }
  };
  const [newDataTrigger, setNewDataTrigger] = useState(undefined);
  const [walletBalance, setWalletBalance] = useState(0);
  const [clientData, setClientData] = useState(undefined);
  useEffect(() => {
    const fetchClientData = async () => {
      const { data: clientData, error: clientError } = await supabase
        .from("Clients")
        .select(
          "id, ghl_location_id, location, club_email, company, stripe_wallet_balance, stripe_customer_id, vapi_payment_setup,location"
        )
        .eq("id", clientId) // Correctly applying the filter
        .single();
      console.log("??");
      if (clientError) {
        console.error("Error fetching client data:", clientError);
      } else {
        const clientLocation = clientData.location;
        setClientLocation(clientLocation);
        setClientData(clientData);
        setWalletBalance((clientData?.stripe_wallet_balance || 0) / 100);
      }
    };
    if (clientId) {
      fetchClientData();
    }
  }, [clientId]);
  useEffect(() => {
    if (clientId) {
      // Real-time listener for new invoices for this email
      const subscription = supabase
        .channel(`Clients:${clientId}`)
        .on(
          "postgres_changes",
          { event: "UPDATE", schema: "public", table: "Clients" },
          (payload) => {
            if (payload.new.id === clientId) {
              // setNewDataTrigger("changed");
              setWalletBalance(payload.new.stripe_wallet_balance / 100);
            }
          }
        )
        .subscribe();
      return () => supabase.removeChannel(subscription);
    }
  }, [clientId]);
  useEffect(() => {
    if (clientId) {
      // Real-time listener for new invoices for this email
      const subscription = supabase
        .channel(`ClientInvoiceHistory:${clientId}`)
        .on(
          "postgres_changes",
          { event: "INSERT", schema: "public", table: "ClientInvoiceHistory" },
          (payload) => {
            if (payload.new.client_id === clientId) {
              setNewDataTrigger("changed");
            }
          }
        )
        .subscribe();
      return () => supabase.removeChannel(subscription);
    }
  }, [clientId]);

  const renderDate = (milliseconds) => {
    const epochTime = milliseconds; // Example: Epoch time in milliseconds

    // Convert to Date object
    const date = new Date(epochTime * 1000).toLocaleString("en-AU", {
      timeZone: "Australia/Sydney",
    });

    return date;
  };
  const isPastDate = (timestamp) => {
    const inputDate = new Date(parseInt(timestamp) * 1000); // Convert to milliseconds
    const now = new Date();
    return inputDate < now;
  };
  const renderStatus = (status_raw, automatically_finalizes_at, due_date) => {
    // draft, open, paid, uncollectible, or void
    let status = status_raw;
    if (status == "draft" && automatically_finalizes_at != null) {
      status = "upcoming";
    }
    if (isPastDate(due_date) && status != "paid" && status != "void") {
      status = "past due";
    }
    const style =
      status == "draft"
        ? {
            border: "1px solid rgb(216, 222, 228)",
            color: "rgb(89, 97, 113)",
            backgroundColor: "rgb(235, 238, 241)",
          }
        : status == "upcoming"
        ? {
            border: "1px solid rgb(255, 223, 128)",
            color: "rgb(154, 115, 19)",
            backgroundColor: "rgb(255, 249, 196)",
          }
        : status == "open"
        ? {
            border: "1px solid rgb(167, 231, 252)",
            color: "rgb(4, 90, 208)",
            backgroundColor: "rgb(203, 245, 253)",
          }
        : status == "paid"
        ? {
            border: "1px solid rgb(168, 241, 112)",
            color: "rgb(33, 112, 5)",
            backgroundColor: "rgb(209, 250, 179)",
          }
        : status == "uncollectible"
        ? {
            border: "1px solid rgb(255, 193, 7)", // Amber border
            color: "rgb(183, 110, 0)", // Dark amber text
            backgroundColor: "rgb(255, 248, 225)", // Soft amber background
          }
        : status == "past due"
        ? {
            border: "1px solid rgb(255, 204, 203)",
            color: "rgb(153, 0, 0)",
            backgroundColor: "rgb(255, 230, 230)",
          }
        : status == "void"
        ? {
            border: "1px solid rgb(222, 215, 247)",
            color: "rgb(94, 53, 177)",
            backgroundColor: "rgb(245, 240, 255)",
          }
        : {
            border: "1px solid rgb(216, 222, 228)",
            color: "rgb(89, 97, 113)",
            backgroundColor: "rgb(235, 238, 241)",
          }; //else
    return (
      <span
        style={{
          ...{
            fontSize: 12,
            textTransform: "capitalize",
            paddingTop: 4,
            paddingBottom: 4,
            paddingRight: 6,
            paddingLeft: 6,

            borderRadius: 8,
          },
          ...style,
        }}
      >
        {status}
      </span>
    );
  };

  const renderStatusButton = (
    status_raw,
    automatically_finalizes_at,
    due_date
  ) => {
    // draft, open, paid, uncollectible, or void
    let status = status_raw;
    if (status == "draft" && automatically_finalizes_at != null) {
      status = "upcoming";
    }
    if (isPastDate(due_date) && status != "paid" && status != "void") {
      status = "past due";
    }
    const style =
      status == "draft"
        ? {
            border: "1px solid rgb(216, 222, 228)",
            color: "rgb(89, 97, 113)",
            backgroundColor: "rgb(235, 238, 241)",
          }
        : status == "upcoming"
        ? {
            border: "1px solid rgb(255, 223, 128)",
            color: "rgb(154, 115, 19)",
            backgroundColor: "rgb(255, 249, 196)",
          }
        : status == "open"
        ? {
            border: "1px solid rgb(167, 231, 252)",
            color: "rgb(4, 90, 208)",
            backgroundColor: "rgb(203, 245, 253)",
          }
        : status == "paid"
        ? {
            border: "1px solid rgb(168, 241, 112)",
            color: "rgb(33, 112, 5)",
            backgroundColor: "rgb(209, 250, 179)",
          }
        : status == "uncollectible"
        ? {
            border: "1px solid rgb(255, 193, 7)",
            color: "rgb(183, 110, 0)",
            backgroundColor: "rgb(255, 248, 225)",
          }
        : status == "past due"
        ? {
            border: "1px solid rgb(255, 204, 203)",
            color: "rgb(153, 0, 0)",
            backgroundColor: "rgb(255, 230, 230)",
          }
        : status == "void"
        ? {
            border: "1px solid rgb(222, 215, 247)",
            color: "rgb(94, 53, 177)",
            backgroundColor: "rgb(245, 240, 255)",
          }
        : {
            border: "1px solid rgb(216, 222, 228)",
            color: "rgb(89, 97, 113)",
            backgroundColor: "rgb(235, 238, 241)",
          };
    const disabled_style =
      status === "draft"
        ? {
            border: "1px solid rgb(229, 231, 235)",
            color: "rgb(144, 149, 157)",
            backgroundColor: "rgb(243, 244, 246)",
            opacity: 0.6,
          }
        : status === "upcoming"
        ? {
            border: "1px solid rgb(255, 236, 179)",
            color: "rgb(201, 166, 85)",
            backgroundColor: "rgb(255, 249, 230)",
            opacity: 0.6,
          }
        : status === "open"
        ? {
            border: "1px solid rgb(197, 236, 252)",
            color: "rgb(100, 154, 202)",
            backgroundColor: "rgb(226, 248, 255)",
            opacity: 0.6,
          }
        : status === "paid"
        ? {
            border: "1px solid rgb(210, 248, 199)",
            color: "rgb(116, 163, 102)",
            backgroundColor: "rgb(233, 252, 223)",
            opacity: 0.6,
          }
        : status === "uncollectible"
        ? {
            border: "1px solid rgb(255, 224, 130)",
            color: "rgb(194, 146, 65)",
            backgroundColor: "rgb(255, 249, 228)",
            opacity: 0.6,
          }
        : status === "past due"
        ? {
            border: "1px solid rgb(255, 214, 213)",
            color: "rgb(187, 75, 75)",
            backgroundColor: "rgb(255, 238, 238)",
            opacity: 0.6,
          }
        : status === "void"
        ? {
            border: "1px solid rgb(236, 229, 255)",
            color: "rgb(141, 114, 202)",
            backgroundColor: "rgb(250, 245, 255)",
            opacity: 0.6,
          }
        : {
            border: "1px solid rgb(229, 231, 235)",
            color: "rgb(144, 149, 157)",
            backgroundColor: "rgb(243, 244, 246)",
            opacity: 0.6,
          };
    let disabled = status == activeFilter;
    return (
      <button
        disabled={disabled}
        onClick={() => {
          setActiveFilter(status);
        }}
        style={{
          ...{
            // fontSize: 12,
            textTransform: "capitalize",
            paddingTop: 8,
            paddingBottom: 8,
            paddingRight: 12,
            paddingLeft: 12,

            borderRadius: 8,
            cursor: disabled ? "not-allowed" : undefined,
          },
          ...style,
          ...(disabled ? disabled_style : {}),
        }}
      >
        {status == "" ? "all" : status}
      </button>
    );
  };
  const [openRowId, setOpenRowId] = useState(null);
  const [usageShistoryList, setUsageShistoryList] = useState([]);
  const [usageSMSHistoryList, setUsageSMSHistoryList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(undefined);
  useEffect(() => {
    fetchData();
  }, [clientId, selectedMonth]);
  function getCustomMonthDates(input) {
    if (!/^\d{4}_\d{2}$/.test(input)) {
      return { firstDay: "", lastDay: "" };
    }
    const [year, month] = input.split("_").map(Number);
    const firstDay = new Date(year, month - 1, 1); // 1st of the given month
    const lastDay = new Date(year, month, 1); // 0th day of next month = last day of current month
    return { firstDay, lastDay };
  }
  function getYearMonth(year_month) {
    if (!/^\d{4}_\d{2}$/.test(year_month)) {
      return { year: "", month: "" };
    }
    const [year, month] = year_month.split("_").map(Number);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return { year: year, month: monthNames[month - 1] || "" };
  }
  const [fetchingUsageHistory, setFetchingUsageHistory] = useState(false);
  const fetchData = async () => {
    /*
    selectedMonth: String
    // 'year_month' from the 
    */
    const { firstDay, lastDay } = getCustomMonthDates(selectedMonth);
    if (!clientId || firstDay == "" || lastDay == "") return; // Don't fetch calls until clientId is available
    setFetchingUsageHistory(true);
    console.log(firstDay, lastDay);
    const { data: calls, error } = await supabase
      .from("Calls")
      .select("*")
      .eq("supabase_client_id", clientId) // Ensure you're filtering calls for the specific client
      .gte("started_at", firstDay.toISOString())
      .lte("started_at", lastDay.toISOString())
      .order("started_at", { ascending: false }); // Sort calls by started_at descending
    if (error) {
      console.error("Error fetching calls:", error);
      setFetchingUsageHistory(false);
    } else {
      // Fetch client data (ghl_location_id) for each call
      const enrichedCalls = await Promise.all(
        //refactored this code for a more faster load time
        calls.map(async (call) => {
          let duration = 0;
          let costs = (call?.costs || [])[0] || [];
          for (let i = 0; i < costs.length; i++) {
            const cost = costs[i];
            call[cost.type + "_cost_breakdown"] = cost;
          }
          return {
            ...call,
            duration,
            ghl_location_id: token || null,
          };
        })
      );
      setUsageShistoryList(enrichedCalls); // Set the enriched data to state
      setFetchingUsageHistory(false);
    }
    const { data: sms, sms_list_error } = await supabase
      .from("SMS")
      .select("*")
      .eq("client_id", clientId) // Ensure you're filtering calls for the specific client
      .gte("date_created", firstDay.toISOString())
      .lte("date_created", lastDay.toISOString())
      .order("date_created", { ascending: false }); // Sort calls by started_at descending
    if (sms_list_error) {
      console.error("Error fetching sms:", error);
    } else {
      // Fetch client data (ghl_location_id) for each call
      const enrichedSMS = await Promise.all(
        //refactored this code for a more faster load time
        sms.map(async (sms) => {
          return {
            ...sms,
            ghl_location_id: token || null,
          };
        })
      );
      console.log("usageSMSHistoryList", enrichedSMS);
      setUsageSMSHistoryList(enrichedSMS); // Set the enriched data to state
    }
    setFetchingUsageHistory(false);
  };
  const [generating, setGenarating] = useState(false);
  const generateCheckoutSession = async () => {
    const stripe_customer_id = clientData?.stripe_customer_id || "";
    const company = clientData?.company || "";
    const location = clientData?.location || "";
    const club_email = clientData?.club_email || "";
    const id = clientData?.id || "";
    setGenarating(true);
    const headers = {
      "Content-Type": "application/json",
    };
    const response = await axios.post(
      "https://automations.creativedigital.ai/webhook/generate-checkout-session",
      {
        customer_id: stripe_customer_id || "",
        id,
        name: company + " " + location,
        company,
        location,
        email: club_email,
      },
      {
        headers: headers,
      }
    );
    if (response.status == 200) {
      setGenarating(false);
      console.log(response.data["checkout-url"]);
      if (response.data["checkout-url"]) {
        const url = response.data["checkout-url"];
        window.open(url, "_blank");
        console.log(response.data["checkout-url"]);
      }
    } else {
      setGenarating(false);
    }
    console.log(response);
  };
  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return hDisplay + mDisplay + sDisplay;
  }
  return [
    <div className="App">
      <LoadingOverlay isLoading={fetchingUsageHistory || generating} />
      <UsageHistoryModal
        isOpen={
          (usageShistoryList.length != 0 || usageSMSHistoryList.length != 0) &&
          selectedMonth
        }
        onClose={() => {
          setUsageShistoryList([]);
          setUsageSMSHistoryList([]);
          setSelectedMonth(undefined);
        }}
        usageShistoryList={usageShistoryList}
        usageSMSHistoryList={usageSMSHistoryList}
        selectedMonth={selectedMonth}
      />
      <div
        style={{
          marginTop: 20,
          marginBottom: 20,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
          position: "relative",
        }}
      >
        <h1>
          SMS & Call Invoice Dashboard {clientLocation && `- ${clientLocation}`}
        </h1>
      </div>
      <div
        style={{
          marginTop: 20,
          marginBottom: 20,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "right",
          gap: 4,
          position: "relative",
        }}
      >
        <div class="balance-card">
          <div class="balance-label">Current Balance</div>
          <div id="balance" class="balance-amount">
            ${(walletBalance || 0).toFixed(2)} AUD
          </div>
          <button
            class="topup-btn"
            disabled={generating}
            onClick={() => {
              generateCheckoutSession();
            }}
          >
            + Top Up Balance
          </button>
        </div>
      </div>
      <div
        style={{
          marginTop: 20,
          marginBottom: 20,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 20,
          position: "relative",
        }}
      >
        {newDataTrigger == "changed" ? (
          <button
            style={{
              position: "absolute",
              right: 10,
            }}
            onClick={() => {
              handlePageChange("prev", true, true);
              setNewDataTrigger(undefined);
            }}
            // newDataTrigger
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              width="18"
              height="18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          </button>
        ) : null}
      </div>
      <div className="table-container">
        <div className="table-wrapper">
          <table>
            <colgroup>
              <col style={{ width: "8%" }} />
              <col style={{ minWidth: "8%" }} />
              <col style={{}} />
              <col style={{}} />

              <col style={{}} />
              <col style={{}} />
              <col style={{}} />
            </colgroup>
            <thead>
              <tr>
                <th>Amount</th>
                {/* <th>Payment</th> */}

                <th>SOA Month</th>
                <th>No. Of Calls</th>
                <th>Total Duration</th>
                <th>No. Of SMS</th>
                <th>Total SMS Segments</th>
                <th style={{ textAlign: "center" }}>Usage History</th>
              </tr>
            </thead>
            {loading ? (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  <p>Loading...</p>
                </td>
              </tr>
            ) : (
              <tbody>
                {list.map((invoice) => {
                  return (
                    <tr key={invoice.id}>
                      <td>$ {((invoice.amount || 0) * 1).toFixed(2)}</td>
                      {/* <td style={{ textAlign: "center" }}>
                      {invoice.status == "open" || invoice.status == "paid" ? (
                        <a
                          className="pay-now-btn"
                          target="_blank"
                          href={invoice.hosted_invoice_url}
                        >
                          {invoice.status == "paid"
                            ? "View Payment Details"
                            : "Pay Now"}
                        </a>
                      ) : null}
                    </td> */}

                      <td>
                        {getYearMonth(invoice.year_month).month}{" "}
                        {getYearMonth(invoice.year_month).year}
                      </td>
                      <td>{invoice.number_of_calls || 0}</td>
                      <td>
                        {secondsToHms(invoice.total_duration_seconds || 0)}
                      </td>
                      <td>{invoice.number_of_sms || 0}</td>
                      <td>{invoice.total_sms_segments}</td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          disabled={loading}
                          onClick={() => {
                            setSelectedMonth(invoice["year_month"]);
                          }}
                        >
                          View History Usage
                        </button>
                      </td>

                      {/* <td style={{ textAlign: "center" }}>
                      {invoice.status == "open" || invoice.status == "paid" ? (
                        <ActionBtn
                          rowId={invoice.id}
                          openRowId={openRowId}
                          setOpenRowId={setOpenRowId}
                          invoice_status={invoice.status}
                          pay_now_link={invoice.hosted_invoice_url}
                          download_link={invoice.invoice_pdf}
                        />
                      ) : null}
                    </td> */}
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>
      </div>
      {loading && list.length == 0 ? null : (
        <div className="pagination">
          <button
            onClick={() => handlePageChange("prev")}
            disabled={currentPage == 1 || loading}
          >
            Previous
          </button>
          <span>{`Page ${currentPage}`}</span>
          <button
            onClick={() => handlePageChange("next")}
            disabled={!hasMore || loading}
          >
            Next
          </button>
        </div>
      )}
    </div>,
  ];
};

export default Dashboard;
